



















































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import InputNyeri from "@/components/nyeri/InputNyeri.vue";
import Durasi from "@/components/pemeriksaan/assesmen/Durasi.vue";
import Frekuensi from "@/components/pemeriksaan/assesmen/Frekuensi.vue";
import FrekuensiNadi from "@/components/pemeriksaan/assesmen/FrekuensiNadi.vue";
import FrekuensiNafas from "@/components/pemeriksaan/assesmen/FrekuensiNafas.vue";
import JenisNyeri from "@/components/pemeriksaan/assesmen/JenisNyeri.vue";
import KualitasNyeri from "@/components/pemeriksaan/assesmen/KualitasNyeri.vue";
import Lokasi from "@/components/pemeriksaan/assesmen/Lokasi.vue";
import Pencetus from "@/components/pemeriksaan/assesmen/Pencetus.vue";
import PenyebabNyeriHilang from "@/components/pemeriksaan/assesmen/PenyebabNyeriHilang.vue";
import PolaSerangan from "@/components/pemeriksaan/assesmen/PolaSerangan.vue";
import SaturasiOksigen from "@/components/pemeriksaan/assesmen/SaturasiOksigen.vue";
import SkalaNyeri from "@/components/pemeriksaan/assesmen/SkalaNyeri.vue";
import SuhuBadan from "@/components/pemeriksaan/assesmen/SuhuBadan.vue";
import TekananDarah from "@/components/pemeriksaan/assesmen/TekananDarahNew.vue";
import AsesmenSurveyPrimerIgd from "@/services/AsesmenSurveyPrimerIgd";
import { appModule } from "@/store/modules/app";
import SurveyPrimerIgdStore from "@/store/modules/SurveyPrimerIgdStore";
import { deriveTriaseSurveyPrimer, toTriaseInput } from "./triaseSurveyPrimer";
// import AsesmenAwalIgd from "@/services/AsesmenAwalIgd";

@Component({
	components: {
		TekananDarah,
		FrekuensiNadi,
		FrekuensiNafas,
		SuhuBadan,
		SaturasiOksigen,
		SkalaNyeri,
		Lokasi,
		Durasi,
		Frekuensi,
		Pencetus,
		KualitasNyeri,
		PolaSerangan,
		PenyebabNyeriHilang,
		JenisNyeri,
		InputNyeri,
	},
})
export default class SurveyPrimerIgdPage extends Vue {
	@Prop() readonly register!: number;
	@Prop() readonly rm!: number;

	airwayOptions = [
		{ id: 1, name: "Dispnoe" },
		{ id: 2, name: "Stridor" },
		{ id: 3, name: "Snoring" },
		{ id: 4, name: "Wheezing" },
		{ id: 5, name: "Gurgling" },
		{ id: 6, name: "Paten" },
	];
	pernapasanOptions = [
		{ id: 1, name: "Spontan" },
		{ id: 2, name: "Tak Spontan" },
	];
	dadaOptions = [
		{ id: 1, name: "Simetris" },
		{ id: 2, name: "Asimetris" },
	];
	pernapasanTypeOptions = [
		{ id: 1, name: "Normal" },
		{ id: 2, name: "Apneu" },
		{ id: 3, name: "Takipneu" },
		{ id: 4, name: "Bardipneu" },
		{ id: 5, name: "Biot" },
		{ id: 6, name: "Cheyne Stoke" },
		{ id: 7, name: "Kusmaul" },
		{ id: 8, name: "Ortopnoe" },
	];
	klinisOptions = [
		{ id: 1, name: "Retraksi" },
		{ id: 2, name: "Cuping Hidung" },
	];
	nadiOptions = [
		{ id: 1, name: "Reguler" },
		{ id: 2, name: "Ireguler" },
		{ id: 3, name: "Kuat" },
		{ id: 4, name: "Lemah" },
	];
	nadiOptions1 = [
		{ id: 1, name: "Reguler" },
		{ id: 2, name: "Ireguler" },
	];
	nadiOptions2 = [
		{ id: 3, name: "Kuat" },
		{ id: 4, name: "Lemah" },
	];
	kulitOptions = [
		{ id: 1, name: "Normal" },
		{ id: 2, name: "Sianosis" },
		{ id: 3, name: "Jaundice" },
		{ id: 4, name: "Diaphoresis" },
		{ id: 5, name: "Pucat" },
	];
	akralOptions = [
		{ id: 1, name: "Hangat" },
		{ id: 2, name: "Dingin" },
	];
	crtOptions = [
		{ id: 1, name: "< 2 detik" },
		{ id: 2, name: "> 2 detik" },
	];
	eksposurOptions = [
		{ id: 1, name: "Deformitas" },
		{ id: 2, name: "Penetrasi" },
		{ id: 3, name: "Burn" },
		{ id: 4, name: "Perforasi" },
		{ id: 5, name: "Jejas" },
		{ id: 6, name: "Laserasi" },
		{ id: 7, name: "Krepitasi" },
		{ id: 8, name: "Abrasi" },
	];
	kesadaranOptions = [
		{ id: 1, name: "Alert" },
		{ id: 2, name: "Voice response" },
		{ id: 3, name: "Pain response" },
		{ id: 4, name: "Unresponse" },
		{ id: 5, name: "Tidak Dapat Dinilai (TDD)" },
	];
	pupilReflekOptions = [
		{ id: 1, name: "Isokor" },
		{ id: 2, name: "Anisokor" },
		{ id: 3, name: "Medriasi maximal" },
		{ id: 4, name: "Pinpoint" },
	];
	reflekCahayaOptions = [
		{ id: 1, name: "Positif" },
		{ id: 2, name: "Negatif" },
	];
	lateralisasiOptions = [
		{ id: 1, name: "Kanan" },
		{ id: 2, name: "Kiri" },
		{ id: 0, name: "Tidak ada" },
	];
	gcsEyeOptions = [
		{ id: 1, name: "Tidak membuka mata" },
		{ id: 2, name: "Dengan rangsangan nyeri" },
		{ id: 3, name: "Dengan perintah suara" },
		{ id: 4, name: "Spontan" },
		{ id: 0, name: "NT" },
	];
	gcsVerbalOptions = [
		{ id: 1, name: "Tidak bersuara" },
		{ id: 2, name: "Mengerang" },
		{ id: 3, name: "Kata" },
		{ id: 4, name: "Orientasi abnormal" },
		{ id: 5, name: "Kalimat lengkap dan orientasi baik" },
		{ id: 0, name: "NT" },
	];
	gcsMotorOptions = [
		{ id: 1, name: "Tidak bergerak" },
		{ id: 2, name: "Response ekstensi abnormal" },
		{ id: 3, name: "Response fleksi abnormal" },
		{ id: 4, name: "Menjauhi nyeri" },
		{ id: 5, name: "Melokalisir nyeri" },
		{ id: 6, name: "Sesuai perintah" },
		{ id: 0, name: "NT" },
	];
	levelKesadaran = [
		{ maxVal: 15, text: "Composmentis" },
		{ maxVal: 13, text: "Apatis" },
		{ maxVal: 11, text: "Delirium" },
		{ maxVal: 9, text: "Somnolen" },
		{ maxVal: 6, text: "Sopor" },
		{ maxVal: 4, text: "Semi Coma" },
		{ maxVal: 3, text: "Coma" },
	];
	asesRisjatOptions = [
		{ id: 0, name: "Tidak Berisiko" },
		{ id: 1, name: "Risiko Sedang" },
		{ id: 2, name: "Risiko Tinggi" },
	];
	asesKecemasanOptions = [
		{ id: 0, name: "Tidak" },
		{ id: 1, name: "Ringan" },
		{ id: 2, name: "Sedang" },
		{ id: 3, name: "Berat" },
	];

	id = null;

	airway = [];
	pernapasan = null;
	dada = null;
	pernapasanType = null;
	klinis = null;
	nadi = null;
	kulit = null;
	akral = null;
	crt = null;
	kesadaran = null;
	pupilReflek = null;
	pupilDiameter = null;
	reflekCahaya = null;
	lateralisasi = null;
	eksposur = null;

	// tvTensi = null;
	tvTensi = {
		sistole: "0",
		diastole: "0",
	};
	tvNadi = null;
	tvNafas = null;
	tvSuhu = null;
	tvSaturasiO2 = null;
	gcsEye = null;
	gcsVerbal = null;
	gcsMotor = null;
	asesRisjat = null;
	asesKecemasan = null;

	nyeriSkala = 0;
	nyeriLokasi = "";
	nyeriFrekuensi = "";
	nyeriDurasi = "";
	nyeriPencetus = "";
	nyeriKualitas = "";
	nyeriPolaSerangan = "";
	nyeriPenyebabHilang = "";
	nyeriJenis = "";

	saving = false;

	setNyeriLokasi(val) {
		this.nyeriLokasi = val;
	}
	setNyeriFrekuensi(val) {
		this.nyeriFrekuensi = val;
	}
	setNyeriDurasi(val) {
		this.nyeriDurasi = val;
	}
	setNyeriPencetus(val) {
		this.nyeriPencetus = val;
	}
	setNyeriKualitas(val) {
		this.nyeriKualitas = val;
	}
	setNyeriPolaSerangan(val) {
		this.nyeriPolaSerangan = val;
	}
	setNyeriPenyebabHilang(val) {
		this.nyeriPenyebabHilang = val;
	}
	setNyeriJenis(val) {
		this.nyeriJenis = val;
	}

	get gcsEyeOpts() {
		return this.gcsEyeOptions.sort((a, b) => b.id - a.id);
	}

	get gcsVerbalOpts() {
		return this.gcsVerbalOptions.sort((a, b) => b.id - a.id);
	}

	get gcsMotorOpts() {
		return this.gcsMotorOptions.sort((a, b) => b.id - a.id);
	}

	get kesadaranDescription() {
		const gcs = this.gcsEye + this.gcsVerbal + this.gcsMotor;

		const val = this.levelKesadaran
			.sort((a, b) => a.maxVal - b.maxVal)
			.find((item) => gcs <= item.maxVal);

		return val && this.gcsEye && this.gcsVerbal && this.gcsMotor
			? val.text
			: "-";
	}

	get triase() {
		return deriveTriaseSurveyPrimer(
			toTriaseInput({
				airway: this.airway,
				pernapasan: this.pernapasan,
				pernapasanType: this.pernapasanType,
				klinis: this.klinis,
				dada: this.dada,
				nadi: this.nadi,
				kulit: this.kulit,
				akral: this.akral,
				crt: this.crt,
				kesadaran: this.kesadaran,
				pupilReflek: this.pupilReflek,
				reflekCahaya: this.reflekCahaya,
				eksposur: this.eksposur,
			}),
		);
	}

	get storeSurvey() {
		return SurveyPrimerIgdStore;
	}

	get input() {
		return {
			id: this.id,
			pasien_rm: this.rm,
			register_id: this.register,
			content: {
				triase: {
					level: this.triase.level,
					label: this.triase.label,
					reasons: this.triase.reasons,
				},
				airway: {
					airway: this.airway,
				},
				breathing: {
					pernapasan: this.pernapasan,
					dada: this.dada,
					pernapasan_type: this.pernapasanType,
					klinis: this.klinis,
				},
				circulation: {
					nadi: this.nadi,
					kulit: this.kulit,
					akral: this.akral,
					crt: this.crt,
				},
				disability: {
					kesadaran: this.kesadaran,
					pupil_reflek: this.pupilReflek,
					lateralisasi: this.lateralisasi,
					pupil_diameter: this.pupilDiameter,
					reflek_cahaya: this.reflekCahaya,
				},
				eksposur: {
					eksposur: this.eksposur,
				},
				tanda_vital: {
					tensi: this.tvTensi,
					nadi: this.tvNadi,
					nafas: this.tvNafas,
					suhu: this.tvSuhu,
					saturasi: this.tvSaturasiO2,
				},
				gcs: {
					eye: this.gcsEye,
					verbal: this.gcsVerbal,
					motor: this.gcsMotor,
				},
				risiko_jatuh: this.asesRisjat,
				kecemasan: this.asesKecemasan,
				nyeri: {
					skala: this.nyeriSkala,
					lokasi: this.nyeriLokasi,
					frekuensi: this.nyeriFrekuensi,
					durasi: this.nyeriDurasi,
					pencetus: this.nyeriPencetus,
					kualitas: this.nyeriKualitas,
					pola_serangan: this.nyeriPolaSerangan,
					penyebab_hilang: this.nyeriPenyebabHilang,
					jenis: this.nyeriJenis,
				},
			},
		};
	}

	mounted() {
		this.getData();
	}

	setTensi(val) {
		console.log("val tensi", val);
		// const sistole = val[0],
		//   diastole = val[1];

		// if (val) {
		//   const td = val.split("/");
		//   sistole = td[0];
		//   diastole = td[1];
		// }

		this.tvTensi = val;
	}

	setFrekNadi(val) {
		this.tvNadi = val;
	}

	setFrekNafas(val) {
		this.tvNafas = val;
	}

	setSuhu(val) {
		this.tvSuhu = val;
	}

	setSaturasiO2(val) {
		this.tvSaturasiO2 = val;
	}

	setSkalaNyeri(val) {
		console.log("set skala nyeri", val);
		this.nyeriSkala = val;
	}

	dummyData() {
		this.airway = this.airwayOptions.filter(({ id }) => id === 1 || id === 2);
		this.pernapasan = this.pernapasanOptions.find(({ id }) => id === 1);
		this.dada = this.dadaOptions.find(({ id }) => id === 2);
		this.pernapasanType = this.pernapasanTypeOptions.find(({ id }) => id === 1);
		this.klinis = this.klinisOptions.find(({ id }) => id === 2);
		this.nadi = this.nadiOptions.filter(({ id }) => id === 1);
		this.kulit = this.kulitOptions.find(({ id }) => id === 2);
		this.akral = this.akralOptions.find(({ id }) => id === 1);
		this.crt = this.crtOptions.find(({ id }) => id === 2);
		this.kesadaran = this.kesadaranOptions.find(({ id }) => id === 1);
		this.pupilReflek = this.pupilReflekOptions.find(({ id }) => id === 2);
		this.pupilDiameter = 20;
		this.reflekCahaya = this.reflekCahayaOptions.find(({ id }) => id === 2);
		this.lateralisasi = this.lateralisasiOptions.find(({ id }) => id === 1);
		this.eksposur = this.eksposurOptions.find(({ id }) => id === 2);
		// this.tvTensi = "120/80";
		this.setTensi("120/80");
		this.tvNadi = "30";
		this.tvNafas = 30;
		this.tvSuhu = 36;
		this.tvSaturasiO2 = 90;
		this.gcsEye = 4;
		this.gcsVerbal = 4;
		this.gcsMotor = 4;
		this.asesRisjat = this.asesRisjatOptions.find(({ id }) => id === 1);
		this.asesKecemasan = this.asesKecemasanOptions.find(({ id }) => id === 1);
		this.nyeriSkala = 3;
	}

	save() {
		if (!this.saving) {
			this.saving = true;

			const sendRequest = this.id
				? AsesmenSurveyPrimerIgd.update(this.id, this.input)
				: AsesmenSurveyPrimerIgd.create(this.input);

			sendRequest
				.then(() => {
					// set store module

					appModule.NoticeDelay("Berhasil Simpan Asesmen Awal IGD");

					this.getData();
				})
				.finally(() => {
					this.saving = false;
				});
		}
	}

	print() {
		// AsesmenAwalIgd.printByRegister(this.register);
	}

	remove() {
		const q = confirm("Hapus Asesmen Survey Primer?");

		if (q) {
			this.deleteData();
		}
	}

	async deleteData() {
		const del = await AsesmenSurveyPrimerIgd.destroy(this.id);

		if (del.data) {
			appModule.NoticeDelay("Berhasil Hapus Asesmen Survey Primer");

			await this.getData();
			this.clearInput();
		}
	}

	getData() {
		SurveyPrimerIgdStore.getByRegister(this.register).then(() => {
			const data = this.storeSurvey.asesmen,
				content = data?.content;

			this.id = data?.id;
			this.airway = content?.airway.airway ?? null;
			this.pernapasan = content?.breathing.pernapasan ?? null;
			this.dada = content?.breathing.dada ?? null;
			this.pernapasanType = content?.breathing.pernapasan_type ?? null;
			this.klinis = content?.breathing.klinis ?? null;
			this.nadi = content?.circulation.nadi ?? null;
			this.kulit = content?.circulation.kulit ?? null;
			this.akral = content?.circulation.akral ?? null;
			this.crt = content?.circulation.crt ?? null;
			this.kesadaran = content?.disability.kesadaran ?? null;
			this.reflekCahaya = content?.disability.reflek_cahaya ?? null;
			this.pupilDiameter = content?.disability.pupil_diameter ?? null;
			this.pupilReflek = content?.disability.pupil_reflek ?? null;
			this.lateralisasi = content?.disability.lateralisasi ?? null;
			this.eksposur = content?.eksposur.eksposur ?? null;
			this.tvTensi = content?.tanda_vital.tensi ?? null;

			this.tvNadi = content?.tanda_vital?.nadi ?? null;
			this.tvNafas = content?.tanda_vital?.nafas ?? null;
			this.tvSuhu = content?.tanda_vital?.suhu ?? null;
			this.tvSaturasiO2 = content?.tanda_vital?.saturasi ?? null;
			this.gcsEye = content?.gcs?.eye ?? null;
			this.gcsVerbal = content?.gcs?.verbal ?? null;
			this.gcsMotor = content?.gcs?.motor ?? null;
			this.asesRisjat = content?.risiko_jatuh ?? null;
			this.asesKecemasan = content?.kecemasan ?? null;
			this.nyeriSkala = content?.nyeri?.skala ? content.nyeri.skala : 0;
			// this.nyeriSkala = 1;
		});
	}

	clearInput() {
		this.id = null;

		this.airway = [];
		this.pernapasan = null;
		this.dada = null;
		this.pernapasanType = null;
		this.klinis = null;
		this.nadi = null;
		this.kulit = null;
		this.akral = null;
		this.crt = null;
		this.kesadaran = null;
		this.pupilReflek = null;
		this.pupilDiameter = null;
		this.reflekCahaya = null;
		this.lateralisasi = null;
		this.eksposur = null;

		this.tvTensi = null;
		this.tvNadi = null;
		this.tvNafas = null;
		this.tvSuhu = null;
		this.tvSaturasiO2 = null;
		this.gcsEye = null;
		this.gcsVerbal = null;
		this.gcsMotor = null;
		this.asesRisjat = null;
		this.asesKecemasan = null;

		this.nyeriSkala = 0;
		this.nyeriLokasi = "";
		this.nyeriFrekuensi = "";
		this.nyeriDurasi = "";
		this.nyeriPencetus = "";
		this.nyeriKualitas = "";
		this.nyeriPolaSerangan = "";
		this.nyeriPenyebabHilang = "";
		this.nyeriJenis = "";
	}

	refreshSurveyPrimer() {
		SurveyPrimerIgdStore.getByRegister(this.register);
	}
}
